import { Component } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgForm } from '@angular/forms';
import { InvoiceApi } from '@app/services/invoice-api';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import { DocumentTypeOptions, InvoiceInterface } from '@app/interface/invoice';
import { MatTableDataSource } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { CompanyApi } from '@app/services/company-api';
import { CompanyInterface } from '@app/interface/company';
import { Observable } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
// import {AsyncPipe} from '@angular/common';
import { map, startWith } from 'rxjs/operators';
// import { OnInit } from '@angular/core';
import { CompanyAutocompleteComponent } from '@app/company-autocomplete/company-autocomplete';
// import { LayoutComponent } from '@app/layout/layout.component';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSort, Sort, MatSortModule } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AfterViewInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import {
  MatExpansionModule,
  MatExpansionPanel,
} from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ConfirmInvoiceDialogComponent } from '@app/confirm-invoice-dialog/confirm-invoice-dialog.component';
import { ConfirmInvoiceDeleteComponent } from '@app/confirm-delete-dialog/confirm-delete-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoadingDialogComponent } from '@app/loading-dialog/loading-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChangeDetectorRef } from '@angular/core';
import { DownloadConfirmationDialogComponent } from '@app/download-confirmation-dialog/download-confirmation-dialog.component';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { ConfirmProgressiveNumberDialogComponent } from '@app/confirm-progressive-number-dialog/confirm-progressive-number-dialog.component';
import { ConfirmInvoiceCompanyDataDialogComponent } from '@app/confirm-invoice-company-data-dialog/confirm-invoice-company-data-dialog.component';
import { MatSelectChange } from '@angular/material/select';
import { Organizations } from '@app/interface/organizations';
import { OrganizationApi } from '@app/services/organization-api.service';
import { ProductserviceApiService } from '@app/services/productservice-api.service';
import { ProductServiceInterface } from '@app/interface/product-service';

@Component({
  selector: 'app-drafts-table',
  templateUrl: './drafts-table.html',
  styleUrls: ['./drafts-table.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatSelectModule,
    MatAutocompleteModule,
    // AsyncPipe,
    // CompanyAutocompleteComponent,
    // LayoutComponent,
    MatPaginatorModule,
    MatPaginator,
    MatCardModule,
    MatCheckboxModule,
    MatSortModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatChipOption,
    MatChipsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionPanel,
    MatTooltipModule,
    MatProgressSpinnerModule,
    BackHeaderComponent,
  ],
  providers: [InvoiceApi, MatSnackBar, CompanyApi],

  standalone: true,
})
export class DraftsTable {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatExpansionPanel) expansionPanel!: MatExpansionPanel;

  private _liveAnnouncer = inject(LiveAnnouncer);

  totalInvoices: number = 0;
  paidInvoices: number = 0;

  filterPanelOpenState = false;
  advancedFilters = false; // Toggle for advanced filters
  max_progressive_number: number = 0;

  getActiveFilterCount(): number {
    return Object.values(this.filters).filter(
      (val) => val !== null && val !== '',
    ).length;
  }

  displayedColumns: string[] = [
    'Actions', // Actions
    'document_type',
    // 'invoice_name',
    'amount',
    // 'currency',
    // 'organization_id',
    'company',
    'description',
    'emission_date',
    'Publish',
    // 'is_paid',
  ];
  dataSource = new MatTableDataSource<InvoiceInterface>([]); // now usng MatTableDataSource
  companySource = new MatTableDataSource<CompanyInterface>([]); // now usng MatTableDataSource

  organization_data: Organizations | null = null;

  myControl = new FormControl('');
  companyNames: string[] = []; // Array to store company names
  filteredOptions!: Observable<string[]>;

  currentYear = new Date().getFullYear();
  years: number[] = [];
  selectedYear: number = this.currentYear;

  showDelay = new FormControl(700);
  hideDelay = new FormControl(1000);

  // filter for the table
  filters: any = {
    amount_gt: null,
    amount_lt: null,
    emission_date_after: null, // New min emission date
    emission_date_before: null, // New max emission date
    payment_date_after: null, // New min payment date
    payment_date_before: null, // New max payment date
    status: null,
    company_name_icontains: null,
  };

  filterOptions = [
    { name: 'Tutte', value: 'all' },
    // { name: 'Paid', value: 'paid' },
    // { name: 'Unpaid', value: 'unpaid' },
  ];
  selectedFilter = 'all';
  filteredInvoices: InvoiceInterface[] = []; // For mobile cards

  documentTypeOptions: DocumentTypeOptions[] = [
    { code: 'TD01', name: 'Fattura' },
    { code: 'TD04', name: 'Nota di credito' },
  ];

  newInvoice: Partial<InvoiceInterface> = {
    invoice_name: '',
    amount: 0,
    organization_id: 1,
    // company: {company_name:'default', id:1},
    company_id: 1,
    currency: 'EUR',
  };

  newCompany: Partial<CompanyInterface> = {
    id: 1,
    company_name: '',
    organization_id: 1,
    company_id: 1,

    iva_number: '',
    ateco_code: '',
  };
  filterValue: string = 'all';

  constructor(
    private snackBar: MatSnackBar,
    private invoiceService: InvoiceApi,
    private companyService: CompanyApi,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private organizationService: OrganizationApi,
    private productServiceApi: ProductserviceApiService,
  ) {}

  isLoading = true;

  ngOnInit() {
    this.loadInvoices();
    this.loadCompanies();
    this.getOrganization();

    this.generateYears();

    // Initialize filteredOptions after companies are loaded
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this._filter(value || '')),
    );
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }

    this.paginator._intl.itemsPerPageLabel = 'Elementi per pagina:';
    this.paginator._intl.nextPageLabel = 'Pagina successiva';
    this.paginator._intl.previousPageLabel = 'Pagina precedente';
    this.paginator._intl.firstPageLabel = 'Prima pagina';
    this.paginator._intl.lastPageLabel = 'Ultima pagina';

    this.paginator._intl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number,
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 di ${length}`;
      }

      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;

      return `${startIndex + 1} - ${endIndex} di ${length}`;
    };
  }

  private getOrganization() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    if (organization_id && !isNaN(organization_id)) {
      const filterParams = {
        organization_id: organization_id,
      };

      console.log(this.organization_data?.source);

      this.organizationService
        .getOrganization<Organizations>(organization_id, filterParams)
        .subscribe({
          next: (organization_data: Organizations) => {
            this.organization_data = organization_data;
            this.cdr.detectChanges();
          },
          error: (err: any) => {
            console.error('Error loading organization:', err);
            this.cdr.detectChanges();
          },
        });
    } else {
      console.error(
        'Could not extract valid organization ID from URL or route parameters',
      );
    }
  }

  generateYears(): void {
    const currentYear = new Date().getFullYear();
    const startYear = 2024; // You can change this start year
    const endYear = currentYear + 2; // You can change this end year

    for (let year = startYear; year <= endYear; year++) {
      this.years.push(year);
    }

    // Optionally set default selection
    this.selectedYear = currentYear;
  }

  onYearSelected(event: MatSelectChange): void {
    this.loadInvoices();
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  // private loadInvoices() {
  //   this.invoiceService.getInvoiceList({}).subscribe({
  //     next: (response: PaginatedResponse<InvoiceInterface>) => {
  //       this.dataSource.data = response.results;
  //       this.dataSource.paginator = this.paginator;

  //       // Calculate statistics
  //       this.totalInvoices = response.results.length;
  //       this.paidInvoices = response.results.filter(
  //         (invoice) => invoice.is_paid
  //       ).length;

  //       console.log('loaded');
  //     },
  //     error: (err: any) => {
  //       console.error('Error loading invoices:', err);
  //       this.showErrorMessage('Failed to load invoices');
  //     },
  //   });
  // }

  getDocumentTypeName(code: string): string {
    const found = this.documentTypeOptions.find(
      (option) => option.code === code,
    );
    return found ? found.name : 'Documento';
  }

  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0]; // Formats as YYYY-MM-DD
  }

  // Riepilogo mostrato in tooltip al passaggio del mouse sulla riga.
  // Il numero di righe prodotto/servizio non arriva con la lista bozze
  // (che contiene solo l'intestazione), quindi viene caricato al primo hover
  // e messo in cache per bozza.
  private productServiceCounts = new Map<number, number>();
  private loadingProductServiceCounts = new Set<number>();

  onRowHover(invoice: InvoiceInterface): void {
    if (
      !invoice?.id ||
      this.productServiceCounts.has(invoice.id) ||
      this.loadingProductServiceCounts.has(invoice.id)
    ) {
      return;
    }

    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.loadingProductServiceCounts.add(invoice.id);

    this.productServiceApi
      .getAllProductsServices<ProductServiceInterface>(
        invoice.id,
        organization_id,
      )
      .subscribe({
        next: (response: RecursiveInterface<ProductServiceInterface>) => {
          if (!response.completed) {
            return;
          }
          this.productServiceCounts.set(invoice.id, response.results.length);
          this.loadingProductServiceCounts.delete(invoice.id);
          this.cdr.markForCheck();
        },
        error: (err: any) => {
          console.error('Error loading product services count:', err);
          this.loadingProductServiceCounts.delete(invoice.id);
        },
      });
  }

  getRowTooltip(invoice: InvoiceInterface): string {
    const documentLine = [
      'Bozza',
      invoice.progressive_number ? `N. ${invoice.progressive_number}` : null,
      invoice.enumeration ? `(${invoice.enumeration})` : null,
    ]
      .filter(Boolean)
      .join(' ');

    const count = this.productServiceCounts.get(invoice.id);

    return [
      documentLine,
      `Descrizione: ${invoice.description?.trim() || '—'}`,
      `Prodotti/servizi: ${count === undefined ? 'caricamento…' : count}`,
      `Totale: ${this.formatTooltipAmount(invoice.amount, invoice.currency)}`,
      `Note: ${invoice.notes?.trim() || '—'}`,
    ].join('\n');
  }

  private formatTooltipAmount(
    amount: number,
    currency: string = 'EUR',
  ): string {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount ?? 0);
  }

  public loadInvoices() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;
    this.cdr.detectChanges();

    // Prepare filter params
    const filterParams: any = {};

    // Add amount filters
    if (this.filters.amount_gt)
      filterParams.amount__gt = this.filters.amount_gt;
    if (this.filters.amount_lt)
      filterParams.amount__lt = this.filters.amount_lt;

    // date filters
    if (this.filters.emission_date_after)
      filterParams.emission_date__gte = this.formatDate(
        this.filters.emission_date_after,
      );
    if (this.filters.emission_date_before)
      filterParams.emission_date__lte = this.formatDate(
        this.filters.emission_date_before,
      );

    if (this.filters.payment_date_after)
      filterParams.payment_date__gte = this.formatDate(
        this.filters.payment_date_after,
      );
    if (this.filters.payment_date_before)
      filterParams.payment_date__lte = this.formatDate(
        this.filters.payment_date_before,
      );

    // Add status filter
    if (this.filters.status) filterParams.status = this.filters.status;

    // Add company name filter
    if (this.filters.company_name_icontains)
      filterParams.company__company_name__icontains =
        this.filters.company_name_icontains;

    setTimeout(() => {
      this.filterPanelOpenState = false;
      // or: this.expansionPanel.close();
    }, 100);

    filterParams.is_draft = true; // ensures only drafts are fetched
    filterParams.is_deleted = false; // hide deleted invoices
    filterParams.is_preventive = false;
    filterParams.is_saved_for_preview = false;
    filterParams.emission_date__year = this.selectedYear;

    // Using getRecursivePage to load all invoices across all pages
    this.invoiceService
      .getAllInvoices<InvoiceInterface>(organization_id, filterParams)
      .subscribe({
        next: (response: RecursiveInterface<InvoiceInterface>) => {
          if (response.completed) {
            // All data has been loaded
            this.dataSource.data = response.results;
            this.dataSource.paginator = this.paginator;

            // Apply current filter
            this.applyFilter(this.selectedFilter);
            this.filteredInvoices = [...response.results]; // Initialize mobile view data

            // Calculate statistics
            this.totalInvoices = response.count; // Use count from response
            this.paidInvoices = response.results.filter(
              (invoice) => invoice.is_paid,
            ).length;

            console.log('All drafts loaded', response.results.length);

            this.isLoading = false;

            this.cdr.detectChanges();
          } else {
            // Optional: Show loading progress if you want
            console.log(`Loaded ${response.results.length} drafts so far...`);
          }
        },
        error: (err: any) => {
          console.error('Error loading drafts:', err);
          this.isLoading = false;
          this.showErrorMessage('Errore durante il caricamento bozze.');
        },
      });
  }

  // function to load companies from interface
  private loadCompanies() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.isLoading = true;

    // Prepare filter params
    const filterParams: any = {};
    filterParams.is_deleted = false; // hide deleted invoices
    this.companyService
      .getAllCompanies<CompanyInterface>(organization_id, filterParams)
      .subscribe({
        next: (companies: RecursiveInterface<CompanyInterface>) => {
          this.companySource.data = companies.results;
          // Extract company names from the response
          this.companyNames = companies.results.map(
            (company) => company.company_name,
          );
          console.log('loaded companies');

          this.isLoading = false;
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error loading companies:', err);
          this.showErrorMessage('Errore durante il caricamento.');
          this.isLoading = false;
          this.cdr.detectChanges();
        },
      });
  }

  resetFilters() {
    this.filters = {
      amount_gt: null,
      amount_lt: null,
      emission_date_after: null,
      emission_date_before: null,
      payment_date_after: null,
      payment_date_before: null,
      status: null,
      company_name_icontains: null,
    };
    this.loadInvoices();
  }

  addNewElement(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // validate required fields
    console.log(
      !this.newInvoice.organization_id || !this.newInvoice.company?.id,
    );
    console.log(this.newInvoice);
    this.invoiceService
      .createInvoice(organization_id, this.newInvoice)
      .subscribe({
        next: (createdInvoice: InvoiceInterface) => {
          this.dataSource.data = [...this.dataSource.data, createdInvoice];
          this.showSuccessMessage(
            `${createdInvoice.progressive_number} (importo ${createdInvoice.amount}) aggiunta con successo!`,
          );
          this.resetForm(form);
        },
        error: (err: any) => {
          console.error('Error creating invoice:', err);
          this.showErrorMessage('Errore durante la creazione fattura.');
        },
      });
  }

  addNewCompany(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // validate required fields
    console.log(!this.newCompany.organization_id || !this.newCompany.id);
    console.log(this.newCompany);
    this.companyService
      .createCompany(organization_id, this.newCompany)
      .subscribe({
        next: (createdCompany: CompanyInterface) => {
          this.companySource.data = [
            ...this.companySource.data,
            createdCompany,
          ];
          this.showSuccessMessage(
            `${createdCompany.company_name} (ID ${createdCompany.id}) added successfully!`,
          );
          this.resetForm(form);
        },
        error: (err: any) => {
          console.error('Error creating company:', err);
          this.showErrorMessage('Errore durante il caricamentoc clienti.');
        },
      });
  }

  // used in the autocomplete?
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.companyNames.filter((option) =>
      option.toLowerCase().includes(filterValue),
    );
  }

  onCompanyNameSelected(companyName: string) {
    const selectedCompany = this.companySource.data.find(
      // companySource?
      (company: { company_name: string }) =>
        company.company_name === companyName,
    );

    if (selectedCompany) {
      this.newInvoice.company_id = selectedCompany.id;
      console.log('Selected company ID:', selectedCompany.id);
    }
  }

  navigateToNewInvoice() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    console.log(org_id);
    this.router.navigate([`/${org_id}/new_invoice`]);
  }

  onRowClick(invoice: InvoiceInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/invoice`, invoice.id]);
  }

  togglePaidStatus(invoice: InvoiceInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.invoiceService
      .updateInvoiceDetails(organization_id, invoice.id, {
        is_paid: invoice.is_paid,
      })
      .subscribe({
        next: (updatedInvoice: any) => {
          // Update the local data
          const index = this.dataSource.data.findIndex(
            (i) => i.id === invoice.id,
          );
          if (index !== -1) {
            this.dataSource.data[index] = updatedInvoice;
            this.dataSource.data = [...this.dataSource.data]; // Trigger update

            // Update statistics
            this.totalInvoices = this.dataSource.data.length;
            this.paidInvoices = this.dataSource.data.filter(
              (i) => i.is_paid,
            ).length;
          }

          this.showSuccessMessage(
            `Invoice ${invoice.invoice_name} updated successfully!`,
          );
        },
        error: (err: any) => {
          console.error('Error updating invoice:', err);
          // Revert the checkbox if the update fails
          invoice.is_paid = !invoice.is_paid;
          this.showErrorMessage('Errore durante la modifica fattura.');
        },
      });
  }

  toggleDraftStatus(invoice: InvoiceInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.invoiceService
      .updateInvoiceDetails(organization_id, invoice.id, { is_draft: false })
      .subscribe({
        next: (updatedInvoice: any) => {
          // Update the local data
          const index = this.dataSource.data.findIndex(
            (i) => i.id === invoice.id,
          );
          if (index !== -1) {
            this.dataSource.data[index] = updatedInvoice;
            this.dataSource.data = [...this.dataSource.data]; // Trigger update

            // Update statistics
            this.totalInvoices = this.dataSource.data.length;
            this.paidInvoices = this.dataSource.data.filter(
              (i) => i.is_paid,
            ).length;
          }

          // this.showSuccessMessage(
          //   `Invoice ${invoice.invoice_name} sent successfully to the server!`
          // );
        },
        error: (err: any) => {
          console.error('Error updating invoice:', err);
          // Revert the checkbox if the update fails
          invoice.is_draft = !invoice.is_draft;
          this.showErrorMessage("Errore nell'invoice. Riprovare.");
        },
      });
  }

  changeDraftProgressiveNumber(
    invoice: InvoiceInterface,
    progressive_number: number,
  ) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    console.log('sel', invoice);

    this.invoiceService
      .updateInvoiceDetails(organization_id, invoice.id, {
        progressive_number: progressive_number,
      })
      .subscribe({
        next: (updatedInvoice: any) => {
          // Update the local data
          // const index = this.dataSource.data.findIndex(
          //   (i) => i.id === invoice.id
          // );
          // if (index !== -1) {
          //   this.dataSource.data[index] = updatedInvoice;
          //   this.dataSource.data = [...this.dataSource.data]; // Trigger update
          //   // Update statistics
          //   this.totalInvoices = this.dataSource.data.length;
          //   this.paidInvoices = this.dataSource.data.filter(
          //     (i) => i.is_paid
          //   ).length;
          // }
          // this.showSuccessMessage(
          //   `Invoice ${invoice.invoice_name} sent successfully to the server!`
          // );
        },
        error: (err: any) => {
          console.error('Error updating invoice:', err);
          // Revert the checkbox if the update fails
          invoice.is_draft = !invoice.is_draft;
          this.showErrorMessage("Errore durante l'invio.");
        },
      });
  }

  setNextProgressiveNumber(): Observable<number> {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    return new Observable<number>((observer) => {
      if (organization_id) {
        this.invoiceService.getMaxProgressiveNumber(organization_id).subscribe({
          next: (maxProgressive: number) => {
            const progressiveNumber = (maxProgressive || 0) + 1;
            console.log(`Auto-set progressive number to: ${progressiveNumber}`);
            observer.next(progressiveNumber);
            observer.complete();
            this.cdr.detectChanges();
          },
          error: (err: any) => {
            console.error('Error fetching max progressive number:', err);
            const fallbackNumber = 1;
            observer.next(fallbackNumber);
            observer.complete();
            this.cdr.detectChanges();
            this.showErrorMessage(
              'Errore nel caricamento del numero progressivo. Usando valore predefinito.',
            );
          },
        });
      } else {
        const fallbackNumber = 1;
        observer.next(fallbackNumber);
        observer.complete();
        this.cdr.detectChanges();
      }
    });
  }

  downloadPdf(invoiceId: number): void {
    try {
      this.invoiceService.downloadInvoicePdf(invoiceId);
      this.showSuccessMessage(
        `La fattura è stata scaricata sul dispositivo con successo!`,
      );
    } catch (error) {
      this.showErrorMessage('Errore download PDF. Riprovare.');
    }
  }

  openDownloadConfirmationDialog(invoice: InvoiceInterface): void {
    const downloadDialogRef = this.dialog.open(
      DownloadConfirmationDialogComponent,
      {
        width: '90vw',
        maxWidth: '500px',
        data: {
          title: `${this.getDocumentTypeName(
            invoice.document_type!,
          )} creata con successo!`,
          documentType: 'Il documento',
          invoiceId: invoice.id!,
          invoiceName: invoice.invoice_name,
          companyName: invoice.company.company_name,
          text: 'è stato creato correttamente.',
        },
      },
    );

    downloadDialogRef.afterClosed().subscribe((result) => {
      if (result && result.download) {
        this.downloadPdf(invoice.id!);
      }
    });
  }

  // to publish the saved draft (after opening the dialog)
  async publishDraft(invoice: InvoiceInterface, form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    console.log('the invoice', invoice);

    // Wait for the progressive number
    // const progressiveNumber =
    //   (await this.setNextProgressiveNumber().toPromise()) || 1;

    // this.changeDraftProgressiveNumber(invoice, progressiveNumber);
    // this.toggleDraftStatus(invoice);
    // invoice.is_draft = false

    // akss the user for confirmation
    const dialogRef = this.dialog.open(ConfirmInvoiceDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '400px',
      data: {
        organization_source: this.organization_data?.source,
      },
    });
    const result = await dialogRef.afterClosed().toPromise();

    if (!result) {
      // User cancelled the dialog
      return;
    }

    let heightOfDialog: string;

    if (invoice.healthcare_invoice) {
      heightOfDialog = '380px';
    } else {
      heightOfDialog = '320px';
    }

    const progressiveNumberDialogRef = this.dialog.open(
      ConfirmProgressiveNumberDialogComponent,
      {
        width: '90vw',
        maxWidth: '400px',
        height: heightOfDialog,
        data: {
          progressive_number: invoice.progressive_number,
          healthcare_invoice: invoice.healthcare_invoice,
        },
      },
    );
    const progressiveNumberresult = await progressiveNumberDialogRef
      .afterClosed()
      .toPromise();

    if (!progressiveNumberresult) {
      // User cancelled the dialog
      return;
    }

    if (invoice.company?.iva_number === '' || invoice.company?.c_f === '') {
      const checkCompanyDialogRef = this.dialog.open(
        ConfirmInvoiceCompanyDataDialogComponent,
        {
          width: '90vw',
          maxWidth: '400px',
          height: '400px',
          data: {
            c_f: invoice.company?.c_f,
            iva_number: invoice.company?.iva_number,
          },
        },
      );
      const checkCompanyResult = await checkCompanyDialogRef
        .afterClosed()
        .toPromise();

      if (!checkCompanyResult) {
        // User cancelled the dialog
        return;
      }
    }

    this.isLoading = true;

    try {
      // User confirmed - show loading dialog
      const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
        width: '90vw',
        maxWidth: '400px',
        height: '300px',
        disableClose: true, // Prevent closing during loading
      });

      // Call the backend to publish to Aruba
      const response = await this.invoiceService
        .publishToAruba(organization_id, invoice.id, invoice)
        .toPromise();

      console.log(response);

      // Close loading dialog
      loadingDialogRef.close();

      // Check if the response indicates success
      if (response.success) {
        this.showSuccessMessage('Fattura pubblicata con successo!');

        // Show download confirmation dialog
        this.openDownloadConfirmationDialog(invoice);

        this.goToinvoiceTable();
      } else {
        // Handle different error types
        if (response.error === 'ARUBA_SYNC_DISABLED') {
          this.showErrorMessage(
            'Sincronizzazione disabilitata: operazione simulata',
          );
        } else {
          if (response.error === 'HEALTHCARE_INVOICE') {
            this.showErrorMessage(
              'Le fatture sanitarie non possono essere inviate.',
            );
          } else {
            this.showErrorMessage(
              response.message || 'Qualcosa è andato storto. Riprova.',
            );
          }
        }
      }
    } catch (error: any) {
      console.error('Error publishing invoice:', error);

      // Handle HTTP errors (4xx, 5xx)
      if (error.error && error.error.error) {
        this.showErrorMessage(error.error.error);
      } else if (error.error && error.error.message) {
        this.showErrorMessage(error.error.message);
      } else if (error.message) {
        this.showErrorMessage(error.message);
      } else {
        this.showErrorMessage('Errore di connessione durante la pubblicazione');
      }
    } finally {
      this.isLoading = false;
    }
  }

  publishDraftWithStop(event: Event, element: InvoiceInterface) {
    event.stopPropagation();
    this.publishDraft(element);
  }

  toggleIsDeletedStatus(invoice: InvoiceInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.invoiceService
      .updateInvoiceDetails(organization_id, invoice.id, { is_deleted: true })
      .subscribe({
        next: (updatedInvoice: any) => {
          // Update the local data
          const index = this.dataSource.data.findIndex(
            (i) => i.id === invoice.id,
          );
          if (index !== -1) {
            this.dataSource.data[index] = updatedInvoice;
            this.dataSource.data = [...this.dataSource.data]; // Trigger update

            // Update statistics
            this.totalInvoices = this.dataSource.data.length;
            this.paidInvoices = this.dataSource.data.filter(
              (i) => i.is_paid,
            ).length;
          }

          this.showSuccessMessage(
            `Invoice ${invoice.invoice_name} successfully deleted!`,
          );
        },
        error: (err: any) => {
          console.error('Error updating invoice:', err);
          // Revert the checkbox if the update fails
          invoice.is_deleted = !invoice.is_deleted;
          this.showErrorMessage('Failed to delete invoice.');
        },
      });
  }

  // deleteInvoice(invoice: InvoiceInterface) {
  //   this.invoiceService.softDeleteInvoice(invoice.id).subscribe({
  //     next: (deletedInvoice) => {
  //       // Remove the invoice from the data source
  //       this.dataSource.data = this.dataSource.data.filter(
  //         (i) => i.id !== invoice.id
  //       );
  //       this.dataSource.data = [...this.dataSource.data]; // Trigger update

  //       // Update statistics
  //       this.totalInvoices = this.dataSource.data.length;
  //       this.paidInvoices = this.dataSource.data.filter(
  //         (i) => i.is_paid
  //       ).length;

  //       this.showSuccessMessage(
  //         `Invoice "${invoice.invoice_name}" deleted successfully!`
  //       );
  //     },
  //     error: (err) => {
  //       console.error('Error deleting invoice:', err);
  //       this.showErrorMessage('Failed to delete invoice');
  //     },
  //   });
  // }

  openCustomerPage(invoice: InvoiceInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/company`, invoice.company.id]);
  }

  // soft delete
  async deleteInvoice(invoice: InvoiceInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(ConfirmInvoiceDeleteComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '250px',
      maxHeight: '90vh',
      data: {
        invoiceName: invoice.invoice_name,
        message: 'Sicuro di voler eliminare la fattura?', // Custom message
        checkboxLabel: 'Confermo di voler eliminare la fattura e accetto', // Custom checkbox label
      },
    });

    const result = await dialogRef.afterClosed().toPromise();

    if (result) {
      // User confirmed deletion - show loading dialog
      const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
        width: '90vw',
        maxWidth: '400px',
        height: '300px',
        disableClose: true, // Prevent closing during loading
      });

      // Simulate 2-second delay + actual API call
      try {
        // Combine fake delay with actual API call
        await Promise.all([
          new Promise((resolve) => setTimeout(resolve, 2000)), // 2-second delay
          this.invoiceService
            .updateInvoiceDetails(organization_id, invoice.id, {
              is_deleted: true,
            })
            .toPromise(),
        ]);

        // Close loading dialog
        loadingDialogRef.close();

        // Remove from local data
        this.dataSource.data = this.dataSource.data.filter(
          (i) => i.id !== invoice.id,
        );
        this.filteredInvoices = this.filteredInvoices.filter(
          (i) => i.id !== invoice.id,
        );

        // Update statistics
        this.totalInvoices = this.dataSource.data.length;
        this.paidInvoices = this.dataSource.data.filter(
          (i) => i.is_paid,
        ).length;

        this.showSuccessMessage(
          `Fattura ${invoice.invoice_name} eliminata con successo!`,
        );
      } catch (err: any) {
        // Close loading dialog on error
        loadingDialogRef.close();

        console.error('Error deleting invoice:', err);
        this.showErrorMessage('Impossibile eliminare la fattura');
      }
    }
  }

  applyFilter(filterValue: string) {
    this.selectedFilter = filterValue;

    // Filter logic for both table and cards
    if (filterValue === 'all') {
      this.dataSource.filter = '';
      this.filteredInvoices = this.dataSource.data;
    } else {
      this.dataSource.filterPredicate = (
        data: InvoiceInterface,
        filter: string,
      ) => {
        if (filter === 'paid') return data.is_paid;
        if (filter === 'unpaid') return !data.is_paid;
        return true;
      };
      this.dataSource.filter = filterValue;
      this.filteredInvoices = this.dataSource.data.filter((invoice) => {
        if (filterValue === 'paid') return invoice.is_paid;
        if (filterValue === 'unpaid') return !invoice.is_paid;
        return true;
      });
    }

    // Update statistics based on filtered data
    const filteredData =
      this.filterValue === 'all' ? this.dataSource.data : this.filteredInvoices;
    this.totalInvoices = filteredData.length;
    this.paidInvoices = filteredData.filter(
      (invoice) => invoice.is_paid,
    ).length;
  }

  private resetForm(form?: NgForm) {
    if (form) {
      form.resetForm();
    }
    ((this.newInvoice = {
      invoice_name: '',
      amount: 0,
      organization_id: 1,
      // company: this.companies[0], // {company_name:'default', id:1}
      company_id: 1,
    }),
      console.log('reset'));
  }

  goToinvoiceTable(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/invoices_table`]);
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['error-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
